import Vue from 'vue';
import Vuex from 'vuex';
import loginModule from './store/modules/security/login';
import listModule from './store/modules/lists';
import userModule from './store/modules/users';
import requestModule from './store/modules/request';
import commonModule from './store/modules/common';
import citizenModule from './store/modules/citizen';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        login: loginModule,
        lists: listModule,
        users: userModule,
        request: requestModule,
        common: commonModule,
        citizen: citizenModule        
    },
    state:{
        showPW: false,
        loading: false,
        showSnackbar:false,
    },
    mutations: {
        updateShowSnackbar: (state, value) => {
            state.showSnackbar = value;
          }
    },
    actions: {},
    getters: {}
});

export default store;